import React from "react"
import {
  SensaiComponentZonesFeatureZone,
  SensaiFeatureSectionsSectionsDynamicZone,
} from "../../gql/generated/graphql"
import { Box } from "@mui/system"
import PaddedContainer from "../ui/PaddedContainer"
import BasicFeature from "./feature-items/BasicFeature"
import QuoteFeature from "./feature-items/QuoteFeature"
import ImpactFeature from "./feature-items/ImpactFeature"

const getContent = (feature: SensaiFeatureSectionsSectionsDynamicZone) => {
  switch (feature.__typename) {
    case "SENSAIComponentFeatureBasic":
      return <BasicFeature feature={feature} />
    case "SENSAIComponentFeatureQuote":
      return <QuoteFeature feature={feature} />
    case "SENSAIComponentFeatureImpact":
      return <ImpactFeature feature={feature} />

    default:
      return <Box>{feature.__typename}</Box>
  }
}

const FeatureZone = (section: SensaiComponentZonesFeatureZone) => {
  const { sections } = section.feature ?? {}
  if (sections?.length === 0) {
    return null
  }

  return <PaddedContainer>{getContent(sections![0]!)}</PaddedContainer>
}

export default FeatureZone
